import type {OpenExpedientCustomerOfferFromTemplateFormPayload} from "./open-expedient-customer-offer-from-template.schema";
import {OpenExpedientCustomerOfferFromTemplateBody} from "@project/sdk/sales/zod";
import {openExpedientCustomerOfferFromTemplate} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientMutationKeys} from "../../../expedient-keys";

export function openExpedientCustomerOfferFromTemplateMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.openExpedientCustomerOfferFromTemplate,
    mutationFn: (payload: OpenExpedientCustomerOfferFromTemplateFormPayload) =>
      openExpedientCustomerOfferFromTemplate(
        id,
        OpenExpedientCustomerOfferFromTemplateBody.parse(payload),
      ),
  });
}
